// extracted by mini-css-extract-plugin
module.exports = {"html":"title_html__Fkhy5","explaination":"title_explaination__XGPjT","textLink":"title_textLink__VpU7s"};